import PropTypes from 'prop-types';
import * as Styled from './StatusButton.styles';

import { resources } from 'oems/resources';

export const StatusButton = ({ children, onClick, variant = 'contained', color = 'primary', loading }) => {
  return (
    <Styled.Wrapper>
      <Styled.Button onClick={onClick} variant={variant} color={color} loading={loading} disabled={loading}>
        <>
          <Styled.Label className="label">{children}</Styled.Label>
          {loading && (
            <Styled.Loading className="loading">
              <resources.LoadingIcon />
            </Styled.Loading>
          )}
        </>
      </Styled.Button>
    </Styled.Wrapper>
  );
};

StatusButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['text', 'contained', 'outlined']),
  color: PropTypes.oneOf(['primary', 'error']),
  loading: PropTypes.bool,
};
